<template>
  <div>
    <v-dialog v-model="dialog" persistent width="400">
      <template v-slot:activator="{ on }">
        <v-btn depressed tile v-on="on" class="primary" small>
          Do Recharge
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="d-flex">
          Recharge or Bill Pay Details
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-form ref="form" v-model="isValid">
            <v-text-field
              label="Mobile or Service Number"
              v-model="phone"
              :rules="rules"
              outlined
              dense
            >
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="green" @click="submit">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <QRCode ref="qrcode" @close="onQRClose"></QRCode>

    <get-commission ref="commission" @continue="doRecharge"></get-commission>
  </div>
</template>

<script>
import { FIELD, PHONE } from "../../assets/js/rules";
import GetCommission from "../recharge/components/GetCommission.vue";
import QRCode from "../recharge/components/QRCode.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { GetCommission, QRCode },
  data() {
    return {
      dialog: false,
      phone: "",
      isValid: false,
    };
  },
  computed: {
    rules() {
      let { service_type } = this.item;
      let list = ["rr", "pp", "dth", "stv"];
      if (service_type) service_type = service_type.toLowerCase();
      if (list.indexOf(service_type) !== -1) return PHONE;
      return FIELD;
    },
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { phone } = vm;
      let { amount, service, service_type } = vm.item;
      let provider = {
        Service: service,
        name: service,
      };
      vm.dialog = false;
      vm.$refs.commission.init({ phone, amount, provider, type: service_type });
    },
    doRecharge() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { amount, service, service_type } = vm.item;
      let { phone } = vm;
      vm.$refs.qrcode.init({
        RechargeNumber: phone,
        Amount: amount,
        ServiceName: service,
        RechargeType: service_type,
        TransId: "NA",
        Circle: "ALL",
      });
    },
    onQRClose(status) {
      if (status) {
        this.$refs.form.reset();
      }
    },
  },
};
</script>

<style>
</style>